import { Navigate } from 'react-router-dom';

export default function DocumentLibrary() {
  return <Navigate to="/documents" replace />;
}
